import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { ParticipantMerchantBilling } from '../models/merchant-billing-models/participant-merchant-billing';

@Injectable({
  providedIn: 'root'
})
export class ParticipantMerchantBillingService {

  constructor(private _httpService: HttpService) {
  }

  public async GetById(merchantBillingId: number): Promise<ParticipantMerchantBilling[]> {
    const httpResult = await this._httpService.apiGet<ParticipantMerchantBilling[]>(`ParticipantMerchantBilling/GetById/${merchantBillingId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }
}
